import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_Prices(data) {
    let response = await apiCall("fuel_prices/create", data);
    return response;
  },
  async list_Prices(data) {
    let response = await apiCall("fuel_prices/list_fuel_prices", data);
    return response;
  },
  async update_Prices(data) {
    let response = await apiCall("fuel_prices/update_fuel_price", data);
    return response;
  },
};
